// Import constants to re-export for easier access across the app
import {
  ANALYTICS_BASE_PATH,
  ANALYTICS_TABS_PATH,
  VERSION,
  ENVELOPE_VERSION,
  EVENT_DETAIL_TYPE,
  EVENT_CATEGORY,
  MODES,
  ACTIONS,
  BUTTONS,
  ACTIVITY,
  MODALS,
  SCREENS,
  LINKS,
  ANALYTICS_BASE_PATH_HP123
} from './constants'

// Export constants as a single object for easier imports
export const ANALYTICS = {
  // paths.js
  ANALYTICS_BASE_PATH,
  ANALYTICS_BASE_PATH_HP123,
  ANALYTICS_TABS_PATH,
  // constants/events.js
  BUTTONS,
  LINKS,
  // constants/activity.js
  ACTIVITY,
  // constants/modalName.js
  MODALS,
  // constants/screenName.js
  SCREENS,
  // constants/metadata.js
  VERSION,
  ENVELOPE_VERSION,
  EVENT_DETAIL_TYPE,
  EVENT_CATEGORY,
  MODES,
  // constants/actions.js
  ACTIONS
}

export {
  useAnalyticsAPI,
  createScreenConfig,
  createModalConfig
} from './hooks/useAnalyticsAPI'

export { getSubOptionScreen } from './utils/getSubOptionScreen'
export { getActionAuxParamsForAnalytics } from './utils/getActionAuxParamsForAnalytics'
